<template>
  <div class="row mt-2">

    <div class="col-6">
      <h1 class="title text-uppercase font-weight-bold">
        Lista de gerente de conta
      </h1>
    </div>

    <div class="col-6 text-right mt-2">
      <button class="btn btn-success" @click="addGerente()">
        <i class="fas fa-plus mr-2"></i>Novo gerente
      </button>
    </div>

    <hr class="linha-amarela" />

    <b-col cols="12" class="mt-4"> 
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="dados.startDate"
        :endDate.sync="dados.endDate"
        @click.native="buscarGerentes()"
      />
    </b-col>

    <div class="col-12 mt-4">

      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th>Id</th>
            <th>Nome</th>
            <th>CPF / CNPJ</th>
            <th>E-mail</th>
            <th>Telefone / Whatsapp</th>
            <th>Status</th>
            <th>Criado em.</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.id }}</td>
            <td>{{ item.nome }} {{ item.sobrenome }}</td>
            <td>{{ item.cpf_cnpj }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.telefoneMask }} / {{ item.whatsappMask }}</td>
            <td :class="item.status == true ? 'ativo' : 'inativo'">{{ item.status == true ? 'Ativo' : 'Inativo' }}</td>
            <td>{{ item.created_at }}</td>
            <td>
              <div class="btn btn-primary mr-2" @click="editGerente(item)">
                <i class="fas fa-edit"></i>
              </div>
              <div :class="item.status == true ? 'btn btn-danger' : 'btn btn-success'" @click="statusGerentes(item.id)">
                <i class="fas fa-ban"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <b-modal
      :title="dados.id == null ? 'Novo gerente de conta' : 'Atualizar gerente de conta'"
      size="xl"
      id="addGerente"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
        <div class="row">
          <div class="col-6">
            <label>Nome:</label>
            <input type="text" class="form-control" v-model="dados.nome" placeholder="Informe o nome do gerente">
          </div>

          <div class="col-6">
            <label>Sobrenome:</label>
            <input type="text" class="form-control" v-model="dados.sobrenome" placeholder="Informe o sobrenome do gerente">
          </div>

          <div class="col-4 mt-2">
            <label>E-mail:</label>
            <input type="text" class="form-control" v-model="dados.email" placeholder="Informe o email do gerente">
          </div>

          <div class="col-4 mt-2">
            <label>CPF / CNPJ:</label>
            <input type="text" class="form-control" v-model="dados.cpf_cnpj" placeholder="###.###.###-## OU ##.###.###/####-##" v-mask="['###.###.###-##', '##.###.###/####-##']"> 
          </div>

          <div class="col-4 mt-2">
            <div class="form-group">
              <label>Nota:</label>
              <select class="form-control" v-model="dados.nota">
                <option value="">-- Selecione --</option>
                <option value="1">Belenus</option>
              </select>
            </div>
          </div>

          <div class="col-6" v-if="empresa == true">
            <label>Nome fantasia:</label>
            <input type="text" class="form-control" v-model="dados.nome_fantasia" placeholder="Informe o nome fantasia do gerente">
          </div>

          <div class="col-6" v-if="empresa == true">
            <label>Razão social:</label>
            <input type="text" class="form-control" v-model="dados.razao_social" placeholder="Informe a razão social do gerente">
          </div>

          <div :class="dados.id != null ? 'col-6 mt-2' : 'col-12 mt-2'">
            <label>Link download do apk:</label>
            <input type="text" class="form-control" v-model="dados.link_apk" placeholder="Link do apk para download">
          </div>

          <div class="col-4 mt-2" v-if="dados.id != null">
            <label>
              Lojista teste / Gerente: {{dados.lojista_id == null ? ' Sem vínculo' : dados.lojista_nome}} 
              <span v-if="dados.lojista_id"> - {{ dados.lojista_id }}</span> 
            </label>
            <input type="text" class="form-control" v-model="dados.lojista_cnpj" placeholder="##.###.###/####-##" v-mask="'##.###.###/####-##'">
          </div>

          <div class="col-2 mt-4" v-if="dados.id != null">
            <button class="btn btn-success btn-block mt-3" @click="vincularGerente()">
              <i class="fas fa-sync mr-2"></i>Vincular
            </button>
          </div>

          <div class="col-6 mt-2">
            <label>Telefone:</label>
            <input type="text" class="form-control" v-model="dados.telefone" placeholder="(##) ####-####" v-mask="['(##) ####-####', '(##) # ####-####']">
          </div>

          <div class="col-6 mt-2">
            <label>WhatsApp:</label>
            <input type="text" class="form-control" v-model="dados.whatsapp" placeholder="(##) # ####-####" v-mask="['(##) ####-####', '(##) # ####-####']">
          </div>

          <div class="col-12 mt-4 text-center">
            <button class="btn btn-success" @click="saveGerente()" v-if="dados.id == null">
              <i class="fas fa-save mr-2"></i>Salvar gerente de conta
            </button>
            <button class="btn btn-success" @click="updateGerente()" v-else>
              <i class="fas fa-save mr-2"></i>Atualizar gerente de conta
            </button>
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import PeriodsFilters from '@/components/Inputs/PeriodsFilters.vue';

import { mapState } from 'vuex';
import makeToast from '../../../mixins/makeToast';

export default {
  name: 'GerenteVendas',
  mixins: [makeToast],
  
  components: {
    PeriodsFilters,
  },

  data() {
    return {
      empresa: false,
      dados: {
        nome: null,
        sobrenome: null,
        cpf_cnpj: null,
        nome_fantasia: null,
        razao_social: null,
        telefone: null,
        whatsapp: null,
        id: null,
        nota: '',
        link_apk: '',
        lojista_id: null,
        lojista_nome: null,
        lojista_cnpj: null,
        startDate: '',
        endDate: ''
      },
      data: []
    }
  },

  watch: {
    'dados.cpf_cnpj': function() {
      this.empresa = false;
      if(this.dados.cpf_cnpj && this.dados.cpf_cnpj.length && this.dados.cpf_cnpj.length > 14) {
        this.empresa = true;
      }
    }
  },

  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },
  created() {
    this.buscarGerentes();
  },
  methods: {
    addGerente() {
      this.limparDados();
      this.$bvModal.show('addGerente');
    },
    saveGerente() {
      const error = this.validForm();
      if(error == false) {
        this.$store.dispatch('startLoader');
        this.$store.dispatch('admin/addGerenteConta', this.dados)
          .then((response) => {
            if(response.data.error == false) {
              this.$bvModal.hide('addGerente');
              this.makeToast('Sucesso', response.data.message, 'success');
              this.buscarGerentes();
            } else {
              this.makeToast('Oopss', response.data.message, 'danger');
            }
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao salvar gerente!', 'danger');
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          })
      }
    },
    buscarGerentes() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/getGerenteConta', this.dados)
        .then((response) => {
          this.data = response.data.data;
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao buscar gerentes!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
      
    },
    statusGerentes(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/upStatusGerente', id)
        .then((response) => {
          if(response.data.error == false) {
              this.makeToast('Sucesso', response.data.message, 'success');
              this.buscarGerentes();
            } else {
              this.makeToast('Oopss', response.data.message, 'danger');
            }
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao atualizar status do gerente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
      
    },
    updateGerente() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/updateGerenteConta', this.dados)
        .then((response) => {
          if(response.data.error == false) {
            this.$bvModal.hide('addGerente');
            this.makeToast('Sucesso', response.data.message, 'success');
            this.buscarGerentes();
          } else {
            this.makeToast('Oopss', response.data.message, 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao atualizar gerente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
      
    },
    vincularGerente() {
      if(this.dados.lojista_cnpj == '' || this.dados.lojista_cnpj == null) {return}

      const data = {
        cnpj: this.dados.lojista_cnpj,
        gerente_id: this.dados.id
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/vincularGerenteConta', data)
        .then((response) => {
          if(response.data.error == false) {
            this.$bvModal.hide('addGerente');
            this.makeToast('Sucesso', response.data.message, 'success');
            this.buscarGerentes();
          } else {
            this.makeToast('Oopss', response.data.message, 'danger');
          }
        })
        .catch(() => {
          this.makeToast('Oopss', 'Erro ao víncular lojista ao gerente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
      
    },
    editGerente(item) {
      this.dados.nome = item.nome;
      this.dados.sobrenome = item.sobrenome;
      this.dados.email = item.email;
      this.dados.cpf_cnpj = item.cpf_cnpj;
      this.dados.nome_fantasia = item.nome_fantasia;
      this.dados.razao_social = item.razao_social;
      this.dados.link_apk = item.link_apk;
      this.dados.lojista_id = item.lojista_id;
      this.dados.lojista_cnpj = item.lojista_cnpj;
      this.dados.lojista_nome = item.lojista_nome;
      this.dados.telefone = item.telefone;
      this.dados.whatsapp = item.whatsapp;
      this.dados.nota = item.nota;
      this.dados.id = item.id;
      this.$bvModal.show('addGerente');
    },
    validForm() {
      var error = false;
      
      if(this.dados.nome == null || this.dados.nome == '') {
        this.makeToast('Oopss', 'Informe o nome!', 'danger');
        error = true;
      }

      if(this.dados.sobrenome == null || this.dados.sobrenome == '') {
        this.makeToast('Oopss', 'Informe o sobrenome!', 'danger');
        error = true;
      }

      if(this.dados.email == null || this.dados.email == '') {
        this.makeToast('Oopss', 'Informe o e-mail!', 'danger');
        error = true;
      }

      if(this.dados.cpf_cnpj == null || this.dados.cpf_cnpj == '') {
        this.makeToast('Oopss', 'Informe o CPF/CNPJ!', 'danger');
        error = true;
      }

      if((this.empresa == true) && (this.dados.nome_fantasia == null || this.dados.nome_fantasia == '')) {
        this.makeToast('Oopss', 'Informe o nome fantasia!', 'danger');
        error = true;
      }

      if((this.empresa == true) && (this.dados.razao_social == null || this.dados.razao_social == '')) {
        this.makeToast('Oopss', 'Informe a razão social!', 'danger');
        error = true;
      }

      if((this.dados.telefone == '' || this.dados.telefone == null) && (this.dados.whatsapp == null || this.dados.whatsapp == '')) {
        this.makeToast('Oopss', 'Informe o telefone ou whatsapp!', 'danger');
        error = true;
      }

      return error;
    },
    limparDados() {
      this.dados.nome = null;
      this.dados.sobrenome = null;
      this.dados.cpf_cnpj = null;
      this.dados.nome_fantasia = null;
      this.dados.razao_social = null;
      this.dados.link_apk = '';
      this.dados.lojista_id = null;
      this.dados.lojista_nome = null;
      this.dados.lojista_cnpj = null;
      this.dados.telefone = null;
      this.dados.whatsapp = null;
      this.dados.nota = null;
      this.dados.id = null;
    }
  },
};
</script>

<style>
@import '../../../custom/css/lista-dicas.css';
.ativo {
  color: green;
}
.inativo {
  color: red;
}
</style>
